<template>

		<div class="video-room" :refs="wrapper" v-if="twilioObject.localParticipant">
			<v-row class="top-row">
				<v-col class="pb-0 pt-0" v-if="main">
					<ParticipantCard class="large-video" :isMain="true" :track="participantTracks[main.user][main.track]" :fullControls="true" v-bind="participants.find(p => p.user == main.user)"></ParticipantCard>
				</v-col>
			</v-row>
			<v-row class="bottom-row">
				<v-col class="pb-0 pt-0">			
					<Participant v-for="participant in participants" :key="participant.user" v-bind="participant" :tracks="participantTracks[participant.user] || {}" @publishNewTrack="publishNewTrack" @unsetTrack="unsetParticipantTrack" @endScreenshare="updateUser('sharing_screen', false)" @pinned="pin" :main="main"> 
					</Participant>
				</v-col>
			</v-row>

		</div>
</template>
<style lang="less">
	.video-room {
		width: 100%;
		position: relative;
		.top-row{
			min-height: 60vh;
		}
		.bottom-row{

		}
	}
	.smallVideo .participant-wrapper{
		width: 100%;
		> div {		
			max-width: 280px;
			min-width: 280px;
			display: inline-block;
		}
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import firebase from "firebase";
	import Participant from "./Participant2"
	import ParticipantCard from "./ParticipantCard"
	import Twilio from 'twilio-video';
	export default {
		name: "VideoRoom", 
		props: {
			room: {},
			settings: {}
		},
		components: {
			Participant,
			ParticipantCard
		},
		data: () => {
			return {
				twilioObject: {}, 
				tracks: [], 
				main: false,
				participantTracks: {}
			}
		},
		created(){
			this.start();	
		}, 
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user, 
				video_room: state => state.video,
				roomInstance: state => state.video.roomInstance
				// local: state => state.video.participant
			}),
			participants(){
				const self = this;
				var participants = this.video_room.participants;
				participants = participants.filter( p => !p.incognito);
				participants = participants.filter( p => p.status == "joined" );
				participants = participants.map( p => {
					p.local = p.user == self.user.uid;
					if( !p.tracks ){
						p.tracks = {}
					}
					return p;
				})

				return participants
			},		
			incognito(){
				return this.video_room.participant.incognito
			},
			width(){
				return this.$refs.wrapper ? this.$refs.wrapper.offsetWidth : false;
			},
			joinSettings(){
				var video = this.settings.video;
				if( video ){
					video = {
						width: this.width
					}
				}
				var settings = {
					room: false,
					audio: false, 
					video: video,
					RecordParticipantsOnConnect: true
				}
				return settings;
			}, 
			firstVisibleParticipant(){
				return this.participants[0]
			},
			firstVisibleParticipantTrack(){
				if( !this.firstVisibleParticipant ){
					return false;
				}
				if( !this.participantTracks[this.firstVisibleParticipant.user] ){
					return false;
				}
				if( this.firstVisibleParticipant.video ){
					return "video"
				}
				else if( this.firstVisibleParticipant.sharing_screen ){
					return "screen"
				}
				return false;
			}

		},
		watch:{
			settings: {
				immediate: true, 
				handler(settings){
					if( !settings ){
						return;
					}
					for( var key in settings ){
						this[key] = settings[key];
					} 
				}
			},	
			incognito: {
				handler(nv, ov){
					if( !ov && nv ){
						this.disconnectEverything();
					}
				}
			},
			twilioObject(){
				this.$emit("twilioObject", this.twilioObject)
			},
			roomInstance(){
				if( this.roomInstance ){				
					var p = {participant: this.user.uid, sid: this.twilioObject.localParticipant.sid } ;
					this.$store.dispatch("addDoc", {
						collection: "videoRooms/" + this.room + "/roomInstances/" + this.roomInstance.id + "/participants/",
						data: p
					})
				}
			},
			firstVisibleParticipantTrack(){
				if( !this.main ){
					this.pinFirst();
				}
			},
		},
		methods: {
			async getAccessToken(){
				const self = this;
				var functions = firebase.app().functions('europe-west1');
				var requestVideoToken = functions.httpsCallable('requestVideoToken');
				return await requestVideoToken({roomName: self.room, identity: self.user.uid});
			},
			async start(){
				const self = this;
				self.getAccessToken().then( (data) => { 
					const token = data.data.token;
					Twilio.connect(token, self.joinSettings).then(function(room) {
						self.twilioObject = room;	
						self.$store.dispatch("video/getRoomInstance", room.sid );

						Array.from(room.localParticipant.tracks.values()).forEach( track => {
							self.setParticipantTrack( self.user.uid, track )
						})

						room.participants.forEach(function (participant) {
							participant.tracks.forEach(function (publication) {
								if (publication.isSubscribed) {
									self.setParticipantTrack( participant.identity, publication )
								}
							});
						});
						room.on("participantConnected", (participant) => {
							Array.from(participant.tracks.values()).forEach( track => {
								self.setParticipantTrack( participant.identity, track )
							})
						})
						room.on("participantDisconnected", (participant) => {
							var existingParticipant = self.participants.find( p => p.user == participant.identity );
							existingParticipant.tracks = {};
						})

						room.on("trackSubscribed", (track, pub, participant ) => {
							track;
							self.setParticipantTrack( participant.identity, pub )
						})
						room.on("trackPublished", (track, participant) => {
							self.setParticipantTrack( participant.indentity, track )
						})
						room.on("trackUnpublished", (track, participant) => {
							self.unsetParticipantTrack( participant.indentity, track )
						})

						//safari
						window.addEventListener('pagehide', () =>{ 
							self.endCall();
						});// all other browsers
						window.addEventListener('beforeunload', () => {
							self.endCall();
						});
					})
				})
			},
			disconnectEverything(){						
				var room = this.twilioObject;
				Array.from(room.localParticipant.tracks.values()).forEach( track => {
					track.track.stop();
					room.localParticipant.unpublishTrack(track.track)
				})
			},
			getTrackType(track){
				if( track.kind == "audio" ) {
					return "audio"
				}
				if( track.kind == "video" ){
					var name = track.trackName;
					var split = name.split("-");
					if( split[0] == "screen" ){
						return "screen"
					}
					else {
						return "video"
					}
				}
			},
			setParticipantTrack(participantId, track){
				const self = this;
				if( !self.participantTracks[participantId] ){
					self.$set(self.participantTracks, participantId, {
						audio: false, 
						video: false, 
						screen: false
					})
				}
				var trackType = self.getTrackType(track);
				self.$set(self.participantTracks[participantId], trackType, track )
			},
			publishNewTrack(participantId, track){
				const self = this;
				if( !track ){
					return;
				}
				self.twilioObject.localParticipant.publishTrack(track).then( (t) => {
					self.setParticipantTrack( participantId, t )
				})
			},
			unsetParticipantTrack(participantId, track){
				const self = this;
				var trackType = self.getTrackType(track);
				if( this.local ){
					self.twilioObject.localParticipant.unpublishTrack(track)
				}
				self.participantTracks[participantId][trackType] = false;
			},			
			updateUser(key, value){
				var data = {}
				data[key] = value;
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
					action: "update", 
					data: data 
				})
			},	
			endCall(){
				const self = this;
				self.disconnectEverything();
				self.twilioObject.disconnect();
				
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
					action: "update", 
					data: {
						status: "disconnected", 
						video: false, 
						sharing_screen: false, 
						audio: false
					} 
				})
			}, 
			pin(participantId, track){
				this.main = false;
				this.main = {user: participantId, track: track};
			}, 
			pinFirst(){
				this.pin(this.firstVisibleParticipant.user, this.firstVisibleParticipantTrack)
			},

		}
		// created(){
			
		// }
	}
// </script>" 